module.exports = __webpack_public_path__ + "static/11-6064ca6d790f4ccf3d50f72796c7965f.jpg";